/* Sleek game pop-up: core (config, copy, rules, helpers) */
(function () {
  var C = window.SleekGameConfig;
  if (!C) return;
  var G = (window.SleekGame = window.SleekGame || {});
  var pet = C.skin === 'pet';
  G.C = C;
  G.pet = pet;
  C.mins = C.mins || { 10: 100, 15: 150, 20: 200 };
  G.minFor = function (t) { return C.mins[t] || C.minSpend; };

  G.T = pet
    ? {
        title: 'Find the Treat', item: 'treat', pieces: 'bowls', one: 'Bowl',
        shuffle: 'BOWL SHUFFLE', watch: 'Eyes on the treat.',
        decoy: 'Find the treat, not the squeaky toy.', pick: "Where's the treat?",
        win: ['Good eye, pet parent. Next level.', 'Found it. Good boy energy.'],
        miss: ['Oops, that bowl was empty.', 'So close. Not that one.'],
        lost: 'The bowls won that round', endNothing: 'The bowls got you this time.',
        card: 'I FOUND THE TREAT TO'
      }
    : {
        title: 'Find the Gift', item: 'gift', pieces: 'domes', one: 'Dome',
        shuffle: 'DOME SHUFFLE', watch: 'Eyes on the gift.',
        decoy: 'Find the gold box, not the silver one.', pick: "Where's the gift?",
        win: ['Good eye. Next level.', 'Found it.'],
        miss: ['That dome was empty.', 'So close. Not that one.'],
        lost: 'The domes won that round', endNothing: 'The domes got you this time.',
        card: 'I FOUND THE GIFT TO'
      };
  G.T.rules = 'Watch the ' + G.T.item + '. Follow the ' + G.T.pieces +
    ". Tap the one it's hiding under. Go further, win more, and if you miss once, your save has your back.";
  G.T.terms = 'One code per person every 30 days. Single use. Minimum spend on eligible items before tax and shipping: $' +
    C.mins[10] + ' for $10 off, $' + C.mins[15] + ' for $15 off, $' + C.mins[20] +
    ' for $20 off. Cannot be combined with any other offer, bundle price or subscription. Not valid on diffusers or scent oils.';

  G.colors = pet ? ['#F7F5F2', '#BFE6D6', '#F4A38C', '#2A2A2A'] : ['#EFE6D8', '#B9C4AE', '#2A2A2A', '#F7F5F2'];
  G.colorFor = function (l) { return G.colors[(l - 1) % 4]; };

  /* Rewards and checkpoints */
  G.TIERS = { 3: 10, 6: 15, 9: 20 };
  G.tierAt = function (l) { return G.TIERS[l] || 0; };
  G.drop = function (h) { return h === 20 ? 15 : h === 15 ? 10 : 0; };
  G.nextOf = function (h) {
    if (h === 10) return { l: 6, a: 15 };
    if (h === 15) return { l: 9, a: 20 };
    if (h === 20) return { l: 10, a: 0 };
    return { l: 3, a: 10 };
  };
  G.lvl = function (l) {
    return {
      n: l <= 3 ? 3 : l <= 5 ? 4 : 5,
      decoy: l === 5 || l >= 7,
      fake: l >= 6,
      rows: l >= 7,
      swaps: 4 + l,
      dur: Math.max(l >= 7 ? 260 : 300, 520 - l * 25)
    };
  };

  /* Helpers */
  G.rand = function (n) {
    try { var a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] % n; }
    catch (e) { return Math.floor(Math.random() * n); }
  };
  G.pickOne = function (a) { return a[G.rand(a.length)]; };
  G.wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  G.ls = {
    get: function (k) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  G.ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  G.claimedRecently = function () {
    var c = G.ls.get('sg_claimed');
    return !!(c && c.t && Date.now() - c.t < 30 * 864e5);
  };
  G.pad = function (n) { return (n < 10 ? '0' : '') + n; };
  G.reduced = function () {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  };

  /* Tracking: Meta pixel if present, Shopify customer events, dataLayer */
  G.track = function (name, p) {
    var d = Object.assign({ skin: C.skin }, p || {});
    try { if (window.fbq) window.fbq('trackCustom', 'SleekGame_' + name, d); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('sleek_game_' + name, d);
    } catch (e) {}
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: 'sleek_game_' + name }, d)); } catch (e) {}
  };

  /* Sound: tiny WebAudio blips, started only after a tap */
  G.sound = G.ls.get('sg_sound');
  if (G.sound === null) G.sound = true;
  var ac = null;
  G.beep = function (f, d, type, vol, delay) {
    if (!G.sound) return;
    try {
      ac = ac || new (window.AudioContext || window.webkitAudioContext)();
      var o = ac.createOscillator(), g = ac.createGain(), s = ac.currentTime + (delay || 0);
      o.type = type || 'sine';
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, s);
      g.gain.exponentialRampToValueAtTime(vol || 0.08, s + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, s + d);
      o.connect(g); g.connect(ac.destination);
      o.start(s); o.stop(s + d + 0.02);
    } catch (e) {}
  };
  G.sfx = {
    tick: function () { G.beep(880, 0.05, 'triangle', 0.02); },
    win: function () { G.beep(660, 0.18, 'sine', 0.08); G.beep(990, 0.25, 'sine', 0.08, 0.12); },
    miss: function () { G.beep(196, 0.35, 'sine', 0.07); },
    reward: function () { [784, 988, 1175, 1568].forEach(function (f, i) { G.beep(f, 0.18, 'triangle', 0.05, i * 0.08); }); }
  };

  G.S = {};
  G.best = G.ls.get('sg_best') || 0;
})();
